import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> & {
  Header: React.FC<CardHeaderProps>;
  Body: React.FC<CardBodyProps>;
  Footer: React.FC<CardFooterProps>;
} = ({ children, className = '' }) => {
  return (
    <div className={`tw-rounded-lg tw-bg-white tw-shadow-md tw-overflow-hidden ${className}`}>
      {children}
    </div>
  );
};

Card.Header = ({ children, className = '' }) => {
  return (
    <div className={`tw-px-6 tw-py-4 tw-border-b tw-border-gray-200 ${className}`}>
      {children}
    </div>
  );
};

Card.Body = ({ children, className = '' }) => {
  return <div className={`tw-p-6 ${className}`}>{children}</div>;
};

Card.Footer = ({ children, className = '' }) => {
  return (
    <div className={`tw-px-6 tw-py-4 tw-border-t tw-border-gray-200 tw-bg-gray-50 ${className}`}>
      {children}
    </div>
  );
};
